import { z } from "zod";

// Esquema de validação regras e mensagens de erro
export const schema = z
	.object({
		id_cliente: z.number().int("Verifique o id_cliente antes de continuar"),
		id_funcionario: z.number().int(),
		id_tipocliente: z.number().int(),
		nome: z.string().min(3, "Por favor, informe o nome do cliente, de no mínimo 3 caracteres"),
		rua: z.string().nullable(),
		numero: z.union([z.string(), z.null()]),
		complemento: z.string().nullable(),
		bairro: z.string().nullable(),
		id_cidade: z.coerce
			.number({ invalid_type_error: "Selecione uma cidade" }) // Converte o valor para número
			.int("O campo id_cidade deve ser um número inteiro.") // Valida que é inteiro
			.refine((val) => val > 0, {
				// Garante que seja maior que 0
				message: "Selecione uma cidade válida",
			}),
		telefone_1: z.string().nullable(),
		telefone_2: z.string().nullable(),
		cpf: z.string().nullable(),
		rg: z.string().nullable(),
		cep: z.string().nullable(),
		pessoafisica: z.boolean(),
		ativo: z.boolean(),
		estadocivil: z.string().nullable(),
		escolaridade: z.string().nullable(),
		status: z.string().nullable(),
		email_contato: z.lazy(() => z.string().email("Digite um e-mail válido").nullable().or(z.literal(""))),
		obs: z.string().nullable(),

		limitevale: z.union([z.string(), z.number()]).transform((value) => {
			// Se for string, converte para número
			if (typeof value === "string") {
				const parsedValue = parseFloat(value.replace(",", "."));
				return isNaN(parsedValue) ? 0 : parsedValue;
			}
			return value; // Já é número, mantém como está
		}),
		// email: z.lazy(() => z.string().email("Digite um e-mail válido").nullable().or(z.literal(""))),
	})
	.refine((data) => !(data.rua && data.rua.trim().length > 0) || (data.numero && data.numero.trim().length > 0), {
		message: "Campo número é obrigatório se a rua estiver preenchida",
		path: ["numero"],
	})
	.refine((data) => !(data.numero && data.numero.trim().length > 0) || (data.rua && data.rua.trim().length > 0), {
		message: "Campo rua é obrigatório se o número estiver preenchido",
		path: ["rua"],
	});

export const schemaDefaultValues = {
	id_cliente: 0,
	// id_funcionario: sessionIdFuncionario, //no hook
	id_tipocliente: 1,
	nome: "",
	rua: "",
	bairro: "",
	numero: "",
	complemento: "",
	id_cidade: 0,
	telefone_1: "",
	telefone_2: "",
	cpf: "",
	rg: "",
	cep: "",
	pessoafisica: true,
	ativo: true,
	estadocivil: "",
	escolaridade: "",
	status: "",
	email_contato: "",
	obs: "",
	limitevale: 0,
};
